module.exports = __webpack_public_path__ + "r-v3/img/control_out.99386759.svg";